import { rem } from "@mantine/core";
import styled from "styled-components";

import { StyledLaboratory } from "@pages/Patients/Laboratory/Laboratory.styled";

import { alignItemsCenter, flexColumn } from "@styles/Utilities.styled";


export const StyledMedicationTable = styled(StyledLaboratory)`
  .header {
    h2 {
      font-weight: 500;
      font-size: ${rem(20)};
    }
  }

  .back-btn-wrapper {
    ${flexColumn}
    gap: 0.35rem;

    .breadcrumb {
      ${alignItemsCenter}
      gap: 0.5rem;
      font-size: ${rem(15)};
      color: var(--clr-primary-400);

      .detail {
        color: var(--clr-gray-400);
      }
    }

    .back-btn {
      ${alignItemsCenter}
      gap: 0.5rem;
      color: var(--clr-primary-400);
      font-size: ${rem(15)};

      svg {
        fill: var(--clr-primary-400);
      }
    }
  }
`;
